import { render, staticRenderFns } from "./BaseSelecte.vue?vue&type=template&id=6a1cd6e4&scoped=true&"
import script from "./BaseSelecte.vue?vue&type=script&lang=js&"
export * from "./BaseSelecte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1cd6e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
